import BaseView from "scripts/views/baseView";

import verifyEmailSuccessSubPage from "templates/verifyEmailSuccessSubPage.hbs";

class VerifyEmailSuccessSubView extends BaseView {
  get template() {
    return verifyEmailSuccessSubPage;
  }

  render() {
    console.log(this);

    this.$el.html(
      this.template({
        emailAddress: this.model.emailAddress,
      }),
    );

    return this;
  }
}

export default VerifyEmailSuccessSubView;
